import DateField from 'components/orders/Filters/Filters/Dates/DateField/styled';

export default DateField;
